export const createTypes = template => ({
  CALL: `${template}_CALL`,
  SUCCESS: `${template}_SUCCESS`,
  ERROR: `${template}_ERROR`
});
